import type { CaravanDb } from '../data/local/db'

export async function lockProtectedCache(db: CaravanDb): Promise<number> {
  return db.transaction('rw', db.settings, db.protectedCache, db.outbox, async () => {
    const previous = await db.settings.get('sync')
    await db.settings.put({
      key: 'sync',
      schemaRevision: previous?.schemaRevision ?? 1,
      mode: previous?.mode ?? 'demo',
      lastCursor: previous?.lastCursor ?? 0,
      lastSuccessfulSyncAt: previous?.lastSuccessfulSyncAt ?? null,
      lastPendingAlertAt: previous?.lastPendingAlertAt ?? null,
      protectedCacheState: 'locked',
    })
    await db.protectedCache.toCollection().modify({ locked: true })
    return db.outbox
      .where('state')
      .anyOf(['pending', 'syncing', 'failed', 'conflict'])
      .modify({ state: 'recovery', lastErrorCode: 'SESSION_REVOKED' })
  })
}
